import { getSessionJWT } from "@/infra/auth/helper";
import { safeEmit } from "@/infra/sockets";
import { AgentSessionType } from "@/modules/sessions/types";
import { getAgentData } from "../states";
import { AGENT_TYPES, AgentData, GapAssessmentTypes, MultiVendorAssessmentTypes, PolicyManagementTypes, QuestionnaireTypes, RiskAssessmentTypes } from "../types";
import { AgentSocketEvents } from "../types/events";
import { VendorRiskSectionEnum } from "../types/vendorAssessment";

export const getAgentTask = (
  agentData: AgentData<
    AGENT_TYPES,
    | RiskAssessmentTypes
    | GapAssessmentTypes
    | QuestionnaireTypes
    | MultiVendorAssessmentTypes
    | PolicyManagementTypes
  >
): string => {
  const { agentType, sessionData, subType } = agentData;

  switch (agentType) {
    case AGENT_TYPES.GAP_ASSESSMENT:
      switch (sessionData.type) {
        case AgentSessionType.SOC2_GAP_TYPE1:
          return 'soc2_type1';
        case AgentSessionType.SOC2_GAP_TYPE2:
          return 'soc2_type2';
				case AgentSessionType.GAP_CUSTOM_FRAMEWORK:
					return "gap_custom_framework"
        default:
          return 'soc2_type2_audit';
      }

    case AGENT_TYPES.MULTI_FILE_VENDOR_ASSESSMENT:
      return 'multi_file_vendor_assessment';

    case AGENT_TYPES.RISK_ASSESSMENT:
			if(subType  === RiskAssessmentTypes.FAIR){
				return 'fair_ra';
			}
      if (sessionData.type === AgentSessionType.RISK_ASSESSMENT) {
        return 'nist_csf_2_risk_assessment';
      }
      break;

    case AGENT_TYPES.QUESTIONNAIRE:
      return 'qa_filler';

    case AGENT_TYPES.POLICY_MANAGEMENT:
      return 'policy_management';

    default:
      return 'nist_ai_rmf';
  }
  return 'nist_ai_rmf';
};

export const useAgentSocket = () => {
	const emitControlEdit = async (
		fileUrl: string,
		control: any,
		controlId: string | any,
		agentId: string,
		stepId: string,
		editedField: string,
	) => {
		try {
			const token = await getSessionJWT();
			const agentData = getAgentData(agentId);
   			if (!agentData) return;

			// Check if this is a supply chain item and add debugging
			const isSupplyChain = control?.section === VendorRiskSectionEnum.vendor_supply_chain;

			

			// Create the payload that will be sent
			const payload = {
				file_url: fileUrl,
				control,
				...(control?.section === VendorRiskSectionEnum.vendor_overview
					? { control_key: controlId }
					: { control_id: controlId }),
				agent_session_id: agentId,
				agent_session_step_id: stepId,
				field: editedField,
				task: getAgentTask(agentData),
			};

			

			safeEmit(
				AgentSocketEvents.CONTROL_EDIT,
				payload,
				(error: Error) => {
					if (error) {
						console.error("Socket emit error:", error);
						if (isSupplyChain) {
							console.error('SOCKET DEBUG - Supply Chain Socket Error:', error);
						}
					} else if (isSupplyChain) {
						console.log('SOCKET DEBUG - Supply Chain Socket Emission SUCCESS');
					}
				},
			);
		} catch (error) {
			console.error("Error in emitControlEdit:", error);
			throw error;
		}
	};

  return { emitControlEdit };
};
